import { DefaultRenderer } from "@googlemaps/markerclusterer";

// Temporary fix for https://github.com/googlemaps/js-markerclusterer/pull/419
export default class MyRenderer extends DefaultRenderer {
    constructor(value) {
        super();
        this.AdvancedMarkerElement = value;
    }
    render(map, cluster, stats) {
        const color = "#088AB2";

        // create svg url with fill color
        const svg = window.btoa(`
        <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" opacity="1" r="100" stroke="#22CCEE" stroke-width="14" />
        </svg>`);

        // create marker using svg icon
        return new window.google.maps.Marker({
            position: map.position,
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new window.google.maps.Size(45, 45),
            },
            label: {
                text: "" + map.markers.length,
                color: "rgba(255,255,255,0.9)",
                fontSize: "12px",
                fontWeight: "800",
            },
            // adjust zIndex to be above other markers
            zIndex: 1000 + map.markers.length,
        });

        // const title = `Cluster of ${map.markers.length} markers`
        // const priceTag = document.createElement("div");

        // priceTag.className = "price-tag";
        // priceTag.textContent = "$3.5M";
        // //const { AdvancedMarkerElement } = window.google.maps.importLibrary("marker");

        // const clusterOptions = {
        //     map: stats,
        //     position: map.position,
        //     title,
        //     content: priceTag,
        //     zIndex: 1000 + map.markers.length
        // };
        // let marker = new this.AdvancedMarkerElement(clusterOptions);

        // return marker
    }
}
